<div class="wrapper">
    <div class="addCompany">
        <app-type-ahead-companies
            [editorInfoAllowAction]="true"
            [searchParameters]="typeAheadSearchByEntityParameters"
            (selectedCompanyChange)="onSelectedCompany($event)"
        >
        </app-type-ahead-companies>
    </div>
    @if (companiesDatasource) {
        <div class="grid">
            <app-server-side-grid
                [colDefs]="gridColumns"
                [datasource]="companiesDatasource"
                [noRows]="noResults()"
                [titleNoData]="'No Companies available.'"
                [getRowId]="getRowIdFn"
            ></app-server-side-grid>
        </div>
    }
</div>
